module.exports = __webpack_public_path__ + "img/sleeve_ruffle_width.d0b02f25.png";